import React from 'react'
import { StyledDeprecation } from './Deprecation.styles'
import type { DeprecationProps } from './Deprecation.types'

export const Deprecation = (props: DeprecationProps) => {
  const { children } = props
  return (
    <StyledDeprecation color="red45" weight="semibold">
      {children}
    </StyledDeprecation>
  )
}
